export default "__VITE_ASSET__Pc0v$Ec$__"